export const truncateString = (str: string, maxLength: number) => {
  if (str.length > maxLength) {
    return str.substring(0, maxLength) + "...";
  }
  return str;
};

/** Matches characters that have a special meaning in a regex literal, so they can be backslash-escaped before being embedded in a dynamic `RegExp`. */
const REGEX_SPECIAL_CHARS = /[.*+?^${}()|[\]\\]/g;

/** Escapes regex metacharacters in `str` so it can be safely interpolated into a `new RegExp(...)` pattern as a literal substring. */
export const escapeRegExp = (str: string) => str.replace(REGEX_SPECIAL_CHARS, "\\$&");

export const nameofFactory = <T>() => {
  return new Proxy(
    {},
    {
      get: (_, prop) => prop,
    }
  ) as {
    [K in keyof T]: K;
  };
};
